export default __webpack_public_path__ + "static/media/shareBlue.e25dc5f2.svg";